import { TContactParam } from '@cian/newbuilding-chat-component';

interface IBuildChatUrl {
  chatHost: string;
  contact: TContactParam;
  gaLabel: string;
}

export function buildChatUrl({ chatHost, contact, gaLabel }: IBuildChatUrl): string {
  const {
    realtyUserId,
    chat: { defaultMessage, entityId, context },
  } = contact;

  return (
    `${chatHost}/dialogs/?hostType=frame&entityId=${entityId}&entityType=newbuilding&receiverUserId=${realtyUserId}` +
    `${context ? '&context=' + encodeURIComponent(window.btoa(JSON.stringify(context))) : ''}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&noDefaultMsgIfChatExists=1' +
    '&pageType=ListingCompareJK'
  );
}
